<template>
  <svg width="22" height="23" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 6H41V42H1V6Z" stroke="currentColor" stroke-width="2" />
    <path d="M11 0V6" stroke="currentColor" stroke-width="2" />
    <path d="M31 0V6" stroke="currentColor" stroke-width="2" />
    <path d="M1 14H41" stroke="currentColor" stroke-width="2" />
    <path d="M7 23H13" stroke="currentColor" stroke-width="2" />
    <path d="M7 33H13" stroke="currentColor" stroke-width="2" />
    <path d="M18 23H24" stroke="currentColor" stroke-width="2" />
    <path d="M29 23H35" stroke="currentColor" stroke-width="2" />
    <path d="M18 33H24" stroke="currentColor" stroke-width="2" />
  </svg>
</template>
